<template>
  <div class="col-12 col-md-6 col-xl">
    <div class="checkout-shipping mb-5" v-if="deliveryOptions.length > 1">
      <div class="checkout-section-heading">
        <ClientOnly><i class="fa-solid fa-truck"></i></ClientOnly>
        <h4>{{ $t("shipping_method") }}</h4>
      </div>
      <div v-if="deliveryOptions.length == 0" class="pb-4 mb-4 ps-5">
        {{ $t("fill_address_information") }}
      </div>
      <div v-for="(deliveryOption, index) of deliveryOptions" :key="`ship-${index}`">
        <div class="form-check pb-4 mb-4 ps-5"
          :class="{ 'border-bottom border-black': index !== deliveryOptions.length - 1 }">
          <input class="form-check-input" v-model="selectedShippingMethod" type="radio" name="deliveryOption"
            :value="`${deliveryOption.carrier_code}|${deliveryOption.method_code}`">
          <label class="form-check-label">{{ formatCurrency(deliveryOption.amount.value) }}&nbsp;&nbsp;{{
            deliveryOption.method_title }}</label>
        </div>
        <div v-if="deliveryOption.method_code == 'instore_pickup'">
          <div class="bank-select">
            <span class="d-block mb-15">{{ $t("branch") }}</span>
            <b-form-group class="select--custom">
              <b-form-select class="select form-control" :options="pickupLocationoptions" text-field="label"
                v-on:change="
                  setPickupLocation(
                    $event
                  )
                  ">
              </b-form-select>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
    <div class="checkout-payment-method mb-5">
      <div class="checkout-section-heading">
        <ClientOnly><i class="fa-solid fa-credit-card"></i></ClientOnly>
        <h4>{{ $t("payment_method") }}</h4>
      </div>
      <div v-if="shippingMethod == null && deliveryOptions.length > 0" class="pb-4 mb-4 ps-5">
        {{ $t("fill_shipping_options") }}
      </div>

      <div v-else-if="selectedShippingMethod !== null">
        <div v-for="(paymentOption, index) in paymentOptions" :key="`pay-${index}`" class="pb-4 mb-4"
          :class="{ 'border-bottom border-black': index !== paymentOptions.length - 1 }">
          <div class="form-check form-check-img-label ps-5">
            <input class="form-check-input" type="radio" name="paymentOption" :value="paymentOption.code"
              v-on:change="checkAllSubOptions(paymentOption.code)" v-model="selectedPaymentMethod">
            <label class="form-check-label" for="payment-bancontact">
              <span class="img-wrapper"><img :src="`${app_url}/media/graphql/icons/50x32/${paymentOption.code}.png`"
                  :alt="paymentOption.code" /></span>
              <span>{{ paymentOption.label }}</span>
            </label>
          </div>
          <div v-if="selectedPaymentMethod === paymentOption.code && paymentOption.additional_fields">
            <div v-for="(field, fIndex) in paymentOption.additional_fields" :key="`field-${fIndex}`" class="ps-3">
              <div v-if="field.type === 'select'" class="ps-5 pt-3">
                <select class="form-select" :value="getPaymentFieldValue(paymentOption.code, field.code)"
                  @change="handlePaymentFieldChange(paymentOption.code, field.code, $event.target.value)">
                  >
                  <option disabled value="">{{ $t("Choose_your_cardtype") }}</option>

                  <option v-for="(opt, oIndex) in field.options" :key="`opt-${oIndex}`" :value="opt.value">
                    {{ opt.label }}
                  </option>
                </select>
                <span v-if="selectCardType" class="form-check form-check-flat ps-0 mt-2 text-danger">
                  {{ $t("Selecteer uw kaarttype") }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="pb-4 mb-4 ps-5">
        {{ $t("fill_payment_options") }}
      </div>
    </div>
  </div>
</template>

<script>
import config from "@config";
import Cart from "@storefront/core/modules/cart/mixins";
import { isAndroid, isIOS, isMacOs } from "mobile-device-detect";
import ClientOnly from "vue-client-only";

export default {
  name: "CheckoutPayment",
  mixins: [Cart],
  components: {
    ClientOnly,
  },
  computed: {
    deliveryOptions() {
      return this.$store.getters["cart/getShippingMethods"];
    },
    pickupLocations() {
      let locations = [...this.$store.getters["cart/getPickupLocations"]];
      locations = locations.map((location) => {
        return {
          ...location,
          name: location.name,
          phone: location.phone,
        };
      });

      let newLocations = [];
      let sortVal = config.pickupSortOptions;
      sortVal.forEach((item) => {
        const index = locations.findIndex(
          (location) =>
            location.pickup_location_code.toLowerCase() == item.toLowerCase()
        );
        if (index > -1) newLocations.push(locations.splice(index, 1)[0]);
      });

      newLocations = [...newLocations, ...locations];
      return newLocations;
    },
    pickupLocationName() {
      if (this.pickupLocation && this.pickupLocation.length > 0) {
        return this.pickupLocations.find(
          (loc) => loc.pickup_location_code === this.pickupLocation
        ).name;
      } else {
        return "";
      }
    },
    pickupLocationPhone() {
      if (this.pickupLocation && this.pickupLocation.length > 0) {
        return this.pickupLocations.find(
          (loc) => loc.pickup_location_code === this.pickupLocation
        ).phone;
      } else {
        return "";
      }
    },
    pickupLocationoptions() {
      return this.pickupLocations.map(location => ({
        value: location.pickup_location_code,
        label: location.name
      }));
    },
    paymentOptions: {
      get() {
        var options = this.$store.getters["cart/getPaymentMethods"];
        let newOptions = [];
        if (options.length > 0) {
          options.forEach((v) => {
            if (/applepay$/.test(v.code)) {
              if (isIOS || isMacOs) {
                newOptions.push(v);
              }
            } else if (/googlepay$/.test(v.code)) {
              if (isAndroid) {
                newOptions.push(v);
              }
            } else {
              newOptions.push(v);
            }
          });
          return newOptions;
        } else {
          return options;
        }
      },
      set() { },

    },
    paymentMethodOptions() {
      return this.$store.getters["cart/getPaymentMethodOptions"];
    },
    cartTotalWithOutTax: function () {
      if (this.$store.getters["cart/getCartIsLoaded"] == true) {
        const prices = this.$store.getters["cart/getCartPrices"];
        if (typeof prices != "undefined") {
          if (typeof prices.subtotal_excluding_tax != "undefined") {
            if (typeof prices.subtotal_excluding_tax.value != "undefined") {
              return prices.subtotal_excluding_tax.value;
            }
          }
        }
        return 0;
      } else {
        return 0;
      }
    },
    getSelectedShippingMethod() {
      const shmed = this.$store.getters["cart/getShippingMethod"];
      this.updateLocalStorage({
        shipping: shmed.carrier_code + "|" + shmed.method_code,
        delivery: null,
      });
      return shmed;
    },
    shippingMethod: {
      get() {
        return this.$store.getters["cart/getShippingMethod"];
      },
      set(shippingMethod) {
        return shippingMethod;
      },
    },
    selectedShippingMethod: {
      get: function () {
        const shmed = this.$store.getters["cart/getShippingMethod"];
        if (shmed != null) {
          return shmed.carrier_code + "|" + shmed.method_code;
        } else {
          return null;
        }
      },
      set: function (value) {
        const delOption = value.split("|");
        this.updateLocalStorage({
          shipping: this.selectedShippingMethod,
          delivery: null,
        });
        this.$store.dispatch("cart/addShippingMethod", {
          carrier: delOption[0],
          method: delOption[1],
        });
        if (this.$gtm.enabled()) {
          let prod = [];
          let items = [];
          this.cartItems.forEach((element) => {
            let i = {
              id: element.product.sku,
              name: element.product.name,
              quantity: element.quantity,
            };
            let it = {
              item_id: element.product.sku,
              item_name: element.product.name,
              quantity: element.quantity,
              price: element.prices.price.value,
            };
            prod.push(i);
            items.push(it);
          });
          if (!this.$gtm.uaDisabled) {
            //GA event
            window.dataLayer.push({
              event: "eec.checkout",
              ecommerce: {
                checkout: {
                  actionField: {
                    step: 3,
                    option: value,
                    action: "checkout",
                  },
                  products: prod,
                },
              },
            });
          }
          if (this.$gtm.ga4Enabled) {
            //GA4 event
            window.dataLayer.push({
              event: "add_shipping_info",
              ecommerce: {
                add: {
                  currency: "EUR",
                  value: this.cartTotalWithOutTax,
                  shipping_tier: value,
                  items: items,
                },
              },
            });
          }
        }
      },
    },
    getSelectedPaymentMethod() {
      const paymed = this.$store.getters["cart/getPaymentMethod"];
      return paymed;
    },
    selectedPaymentMethod: {
      get: function () {
        var paymentMethod = this.$store.getters["cart/getPaymentMethod"];
        if (!paymentMethod && this.localStorageData.billing) {
          paymentMethod = this.localStorageData.billing;
        }
        return paymentMethod;
      },
      set: function (method) {
        this.updateLocalStorage({ billing: method });
        this.$store.commit("cart/setPaymentMethod", method);
        if (this.$gtm.enabled()) {
          let prod = [];
          let items = [];
          this.cartItems.forEach((element) => {
            let i = {
              id: element.product.sku,
              name: element.product.name,
              quantity: element.quantity,
            };
            let it = {
              item_id: element.product.sku,
              item_name: element.product.name,
              quantity: element.quantity,
              price: element.prices.price.value,
            };
            prod.push(i);
            items.push(it);
          });
          window.dataLayer.push({
            event: "eec.checkout",
            ecommerce: {
              checkout: {
                actionField: {
                  step: 2,
                  option: method,
                  action: "checkout",
                },
                products: prod,
              },
            },
          });
          if (this.$gtm.ga4Enabled) {
            //GA4 event
            window.dataLayer.push({
              event: "add_payment_info",
              ecommerce: {
                add: {
                  currency: "EUR",
                  value: this.cartTotalWithOutTax,
                  payment_type: method,
                  items: items,
                },
              },
            });
          }
        }
      },
    },
  },
  methods: {
    formatCurrency(value) {
      var formatter = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      });
      return formatter.format(value);
    },
    getPaymentFieldValue(paymentMethodCode, fieldCode) {
      const options = this.paymentMethodOptions;
      if (options && options[paymentMethodCode] && options[paymentMethodCode][fieldCode]) {
        return options[paymentMethodCode][fieldCode];
      }
      return '';
    },


    handlePaymentFieldChange(paymentMethodCode, fieldCode, selectedValue) {
      this.setPaymentMethodOptions(paymentMethodCode, fieldCode, selectedValue);
      this.selectCardType = false;
    },

    setPaymentMethodOptions(paymentMethod, option_key, issuer_id) {
      if (paymentMethod) {

        this.$store.commit("cart/updateCartPaymentMethodOptions", {
          key: paymentMethod,
          sub: option_key,
          value: issuer_id,
        });


        this.updateLocalStorage({
          billing: paymentMethod,
          issuer: issuer_id,
        });
      }
    },

    setPickupLocation(PickupLocation) {
      if (PickupLocation) {
        this.updateLocalStorage({
          delivery: PickupLocation
        });
      }
    },
    storage() {
      this.localStorageData =
        JSON.parse(localStorage.getItem("checkoutPayment")) ?? {};
      this.localStorageData.shipping
        ? (this.selectedShippingMethod = this.localStorageData.shipping)
        : "";
      this.localStorageData.delivery
        ? ((this.pickupLocation = this.localStorageData.delivery),
          (this.showPickupLocation = true),
          (this.selectedPickupLocation = this.localStorageData.delivery))
        : "";
      this.localStorageData.billing
        ? (this.selectedPaymentMethod = this.localStorageData.billing)
        : null;
    },
    checkAllSubOptions() {
      this.showPaymentSuboptions = "collapse show";
      this.isPaymentSelected = true;
      this.showPaymentRequired = false;
    },
    updateLocalStorage(data) {
      this.localStorageData = Object.assign({}, this.localStorageData, data);
      localStorage.setItem(
        "checkoutPayment",
        JSON.stringify(this.localStorageData)
      );
    },
    checkFields() {
      var errorFields = []
      if (!this.selectedShippingMethod && this.deliveryOptions.length > 0) {
        errorFields.push(this.$t("shipping_method"));
      }

      if (!this.selectedShippingMethod && this.deliveryOptions.length > 1) {
        this.$store.commit("cart/setStoreValidation", {
          payment: errorFields,
        });
        console.log("checkFields - shipping method required", errorFields);
        return;
      }

      if (!this.paymentOptions || this.paymentOptions.length === 0) {
        errorFields.push(this.$t("Payment_method_error"));
        this.$store.commit("cart/setStoreValidation", {
          payment: errorFields,
        });
        console.log("checkFields - payment methods not loaded", errorFields);
        return;
      }

      if (!this.selectedPaymentMethod && !this.getSelectedPaymentMethod) {
        errorFields.push(this.$t("Payment_method_error"));
      }
      else if (this.isPaymentSelected == false) {
        errorFields.push(this.$t("Payment_method_error"));
      }
      else if (this.selectedPaymentMethod == "multisafepay_ideal") {
        if (
          !this.paymentMethodOptions.multisafepay_ideal ||
          !this.paymentMethodOptions.multisafepay_ideal.issuer_id
        ) {
          errorFields.push(this.$t("Bank"));
        }
      } else if (this.selectedPaymentMethod == "buckaroo_magento2_creditcard") {
        if (this.paymentMethodOptions.buckaroo_magento2_creditcard.cards === null) {
          this.selectCardType = true;
          errorFields.push(this.$t("Selecteer uw kaarttype"));
        } else {
          this.selectCardType = false;
        }
      }
      if (errorFields.length > 0) {
        this.$store.commit("cart/setStoreValidation", {
          payment: errorFields,
        });
      } else {
        this.$store.commit("cart/setStoreValidation", {
          payment: [],
        });
      }
    },
  },
  mounted() {
    this.storage();
    this.$root.$on("checkFields", () => {
      this.checkFields();
    });
  },
  data: () => ({
    app_url: config.app_url,
    showPaymentRequired: false,
    isPaymentSelected: false,
    selectedIssuer: null,
    localStorageData: { billing: "", delivery: null, issuer: "", shipping: "" },
    showPaymentSuboptions: "collapse show",
    selectCardType: false,
    isSettingShippingMethod: false,
  }),
  watch: {
    showPickupLocation() {
      this.setShippingMethod();
    },
    async pickupLocation(code) {
      const response = await this.$store.dispatch("cart/setPickupLocation", {
        code,
      });
      if (response) {
        const delOption = this.selectedShippingMethod.split("|");
        await this.$store.dispatch("cart/addShippingMethod", {
          carrier: delOption[0],
          method: delOption[1],
        });
        this.selectedPickupLocation = await this.$store.getters[
          "cart/getShippingAddress"
        ];
        this.updateLocalStorage({
          shipping: this.selectedShippingMethod,
          delivery: code,
        });
      }
    },
    selectedShippingMethod(method) {
      const [carrier_code, method_code] = method.split("|");
      this.updateLocalStorage({
        shipping: this.selectedShippingMethod,
        delivery: null,
      });
      this.$store.dispatch("cart/addShippingMethod", {
        carrier: carrier_code,
        method: method_code,
      });
      if (this.$gtm.enabled()) {
        let prod = [];
        this.cartItems.forEach((element) => {
          let i = {
            id: element.product.sku,
            name: element.product.name,
            quantity: element.quantity,
          };
          prod.push(i);
        });
        window.dataLayer.push({
          event: "eec.checkout",
          ecommerce: {
            checkout: {
              actionField: {
                step: 3,
                option: method,
                action: "checkout",
              },
              products: prod,
            },
          },
        });
      }
    },
    paymentMethodOptions(method) {
      if (
        method &&
        method.multisafepay_ideal &&
        !method.multisafepay_ideal.issuer_id
      ) {
        if (this.localStorageData.issuer) {
          this.setPaymentMethodOptions(
            "multisafepay_ideal",
            "issuer_id",
            this.localStorageData.issuer
          );
        }
      }
    },
    deliveryOptions(newVal) {
      if (newVal.length === 1) {
        const option = newVal[0];
        const newMethod = `${option.carrier_code}|${option.method_code}`;
        if (this.selectedShippingMethod !== newMethod) {
          this.selectedShippingMethod = newMethod;
        }
      } else if (newVal.length > 1) {
        if (this.selectedShippingMethod !== null) {
          this.selectedShippingMethod = null;
        }
      }
    }

  },
};
</script>

<style></style>
